export default {
      id: "ic_close-usage",
      viewBox: "0 0 18 18",
      url: "/" + "images/icons.3.109.2.svg#ic_close-usage",
      toString: function () {
        return this.url;
      }
    }